import { TFileSchema } from '@conversed/shared/src/central/types/common.type';
import z from 'zod';
import { createRESTContract } from '../../index';

export const contactLookupContract = createRESTContract({
  importContactLookup: {
    method: 'POST',
    path: '/contact-lookup/import',
    permissions: [],
    body: z.object({
      file: TFileSchema,
    }),
    response: z.object({
      rowCount: z.number(),
      skippedRows: z.number(),
      missingFields: z.record(z.string(), z.number()),
    }),
  },
});
